<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Select A System User"
      id="admin_add_admin_select_user"
    ></CardedSectionHeader>
    <div v-show="progress == 1">
      <AdminUsersList
        :is_adding_admin="true"
        @on-selected-system-user="on_selected_system_user"
      >
      </AdminUsersList>
    </div>
    <div v-show="progress == 2">
      <CardedForm
        ref="admin_add_system_user_form_ref"
        id="admin_add_system_user_form"
        title="_"
        :is_loading="is_loading"
        @on-submit-form="submit"
        :errors="errors"
        :message="message"
        @on-auto-fill="on_auto_fill"
        @on-close-message="on_hide_message"
      >
        <div>
          <div class="text-left">
            <div class="inline wdth-150 text-left mr-10">ID :</div>
            <b>#{{ selected_user.id }}</b>
          </div>
          <div class="text-left">
            <div class="inline wdth-150 text-left mr-10">First Name :</div>
            <b>{{ selected_user.first_name }}</b>
          </div>
          <div class="text-left">
            <div class="inline wdth-150 text-left mr-10">Last Name :</div>
            <b>{{ selected_user.last_name }}</b>
          </div>
          <div class="text-left">
            <div class="inline wdth-150 text-left mr-10">Username :</div>
            <b>{{ selected_user.email }}</b>
          </div>
        </div>
        <v-row no-gutterss class="pa-0 mb-0 pt-5">
          <v-col no-gutters class="pb-0 pt-0 mb-0">
            <TextField
              v-model="form.username"
              :validation_rules="form_validations.username"
              label="Enter System Users Login Username exactly "
              icon="mdi-pen-plus"
              :disabled="is_loading"
            ></TextField>
          </v-col>
        </v-row>
      </CardedForm>
    </div>

    <v-dialog v-model="show_errors_dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-1">
          <v-icon large class="mr-1" color="red">mdi-alert</v-icon>
          Error Information Display</v-card-title
        >
        <v-divider></v-divider>
        <br />
        <v-card-text v-for="(error, index) in errors" :key="index">
          <div style="font-size: 16px; color: #5a5555" class="h4">
            {{ index + 1 }}) {{ error }}
          </div>
          <v-divider></v-divider>
        </v-card-text>
        <br />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            class="hgt-40 round-4"
            tile
            filled
            ripple
            @click="show_errors_dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import TextField from "../../../components/TextField";
import CardedForm from "../../../components/CardedForm";
import AdminUsersList from "./AdminUsersList";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminAddSystemAdmins",
  components: {
    CardedSectionHeader,
    AdminUsersList,
    CardedForm,
    TextField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      system_user_id: 0,
      system_user: Utils.get_default_system_user(),
      errors: [],
      message: "",
      form: {
        username: "",
      },
      form_validations: {
        username: [
          Utils.validate.is_required("Users login username is required"),
          Utils.validate.email_format_or_phone(
            "Invalid input, must be a valid email address or a valid phone number"
          ),
        ],
      },
      progress: 1,
      show_errors_dialog: false,
      selected_user: Utils.get_default_system_user(),
    };
  },
  methods: {
    load_system_users() {
      this.errors = [];
      this.message = "";
      this.show_errors_dialog = false;
      this.$emit("on-show-loader");
      ServerClient.Security.get_system_user(
        {
          id: this.system_user_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.system_user = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.show_errors_dialog = true;
        }
      );
    },
    on_selected_system_user(user) {
      this.errors = [];
      this.message = "";
      this.show_errors_dialog = false;
      this.selected_user = Utils.get_default_system_user();

      //check if user is already an admin
      this.$emit("on-show-loader");
      ServerClient.Security.is_user_admin(
        {
          id: user.id,
        },
        (is_admin) => {
          this.$emit("on-hide-loader");
          if (is_admin == true) {
            this.errors = ["Selected User is already an admin"];
            this.show_errors_dialog = true;
          } else {
            this.progress = 2;
            this.selected_user = user;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.show_errors_dialog = true;
        }
      );
    },
    on_auto_fill() {
      this.errors = [];
      this.message = "";
      this.show_errors_dialog = false;
      this.form.username = this.selected_user.email;
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.show_errors_dialog = false;
      this.$emit("on-show-loader");
      ServerClient.Security.make_admin(
        {
          id: this.selected_user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message = "<b>Admin was added successfully</b> Please note that, the <b class='success--text'>new admin user has to logout and login again</b> for his effects to take place";
          this.$refs.admin_add_system_user_form_ref.show_message_dialog();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.show_errors_dialog = true;
        }
      );
    },
    on_hide_message() {
        this.errors = [];
      this.message = "";
      this.show_errors_dialog = false;
      this.progress = 1;
      this.selected_user = Utils.get_default_system_user();
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.progress = 1;
    this.$emit("set-page-attributes", {
      title: "Add System Admin",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Users",
          disabled: false,
          href: "/admin/users",
        },
        {
          text: "Admins",
          disabled: false,
          href: "/admin/users/admin/list",
        },
        {
          text: "New",
          disabled: true,
          href: "/admin/users/admin/add",
        },
      ],
    });
    this.load_system_users();
  },
};
</script>